import { render, staticRenderFns } from "./InvitationNotifications.vue?vue&type=template&id=88007d7e&scoped=true&"
import script from "./InvitationNotifications.vue?vue&type=script&lang=js&"
export * from "./InvitationNotifications.vue?vue&type=script&lang=js&"
import style0 from "./InvitationNotifications.vue?vue&type=style&index=0&id=88007d7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88007d7e",
  null
  
)

export default component.exports